import { gql } from "@apollo/client";

export const GET_USER_CHAT_GROUPS = gql`
  query UserChatGroups {
    userChatGroups {
      id
      name
      description
      opportunityId
      opportunity {
          id
          slug
          title
      }
      members {
        id
        name
        role
      }
    }
  }
`;

export const GET_USER_CHAT_GROUP_NOTIFICATIONS = gql`
  query userChatGroupNotifications {
    userChatGroupNotifications {
      id
      isRead
      message
      group {
        id
        description
        opportunity {
          id
          slug
          title
      }
      }
    }
  }
`;

export const GET_USER_CHAT_GROUP_UNREAD_NOTIFICATIONS_COUNT = gql`
  query userChatGroupUnreadNotificationsCount {
    userChatGroupUnreadNotificationsCount
  }
`;
